module.exports = __webpack_public_path__ + "media/images/footer/railslove-b4bcb8878fad0b322ef171d82ed02b4b.svg";